<div class="main-body">
  <div class="main-player-body">
    <app-player></app-player>
  </div>
  <div class="main-content-body">
    <router-outlet></router-outlet>
  </div>
</div>
